import React from "react";
import { Redirect, Route } from "react-router-dom";
import useAuth from "../hooks/useAuth";

export const SystemRoutes = ({ component: Component, ...rest }) => {
  const { auth } = useAuth();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!auth?.roles.length) {
          return <Component {...props} title={rest.title} />;
        } else {
          return (
            <Redirect
              to={{
                pathname: "/not-found",
                state: {
                  from: props.location,
                },
              }}
            />
          );
        }
      }}
    />
  );
};

export default SystemRoutes;
